import { combineReducers } from 'redux';
import { workspacesReducer } from './workspaces/reducer';
import {
    limitsReducer,
    runReducer,
    runsListReducer,
    runToCopyReducer,
    scenariosReducer
} from './runs/reducers';
import {
    comparisonReducer,
    workspaceConfigReducer
} from './comparison/reducers';

export const simulationReducer = combineReducers({
    workspaces: workspacesReducer,
    runs: runsListReducer,
    scenarios: scenariosReducer,
    limits: limitsReducer,
    run: runReducer,
    runToCopy: runToCopyReducer,
    workspaceConfig: workspaceConfigReducer,
    comparison: comparisonReducer
});
